import React from 'react';
import { Justify, JustifyProps } from "tea-component";
import classNames from "classnames";
import './index.scss';

/**
 * 因为 tea组件的 Justify的 fontSize默认是0, 每次都要修改, 所以写一个覆盖样式的
 */
const CustomJustify = (props: JustifyProps) => {
  const { className,  ...rest } = props;
  return (<Justify
    {...rest}
    className={classNames('dbl-custom-justify', className)}
  />);
};

export default CustomJustify;